<a tabindex="0" [href]="skipPath()" (click)="handleClick($event)">{{ 'frontpage.skip' | translate }}</a>